import React from 'react';
import './loading.css';
const LoadingFull = () => {
	return (
		<>
			{/* <div className="center-loading">
				<div className="ring-loading"> </div>
				<span>Wait for TXN...</span>
			</div> */}
			<div className="center-loading">
				<div className="spinner-box">
					<div className="blue-orbit leo"></div>
					<div className="green-orbit leo"></div>
					<div className="red-orbit leo"></div>
					<div className="white-orbit w1 leo"></div>
					<div className="white-orbit w2 leo"></div>
					<div className="white-orbit w3 leo"></div>
					<div className='wait-des'>Wait for transaction...</div>
				</div>
			</div>
		</>
	);
};

export default LoadingFull;
